import { render, staticRenderFns } from "./modalClaimNoteEdit.vue?vue&type=template&id=447a3448&"
import script from "./modalClaimNoteEdit.vue?vue&type=script&lang=js&"
export * from "./modalClaimNoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports